import React from 'react';

import { observer } from 'mobx-react';

import classes from './TwoFAStep.module.scss';
import { SubmitButton } from '../../components/SubmitButton/SubmitButton';
import { entitySignUpStore } from '../../../../../shared/stores/entity/entitySignUpStore';
import { TwoFAAuth } from '../../../../../auth-management';

type TwoFAStepProps = {
  phoneNumber: string | null;
  onVerifyCode: (consumer: string, code: string) => Promise<void>;
};

const twoFaAuthFormId = 'two-fa-auth-form';

const TwoFAStep = observer(({ phoneNumber, onVerifyCode }: TwoFAStepProps) => {
  const { entityId } = entitySignUpStore;

  if (!entityId || !phoneNumber) {
    throw new Error('Entity ID or phone number is not defined');
  }

  return (
    <>
      <h1 className={classes.pageTitle}>Welcome to ScanIQ!</h1>
      <TwoFAAuth
        formId={twoFaAuthFormId}
        onVerifyCode={onVerifyCode}
        phoneNumber={phoneNumber}
      />
      <SubmitButton formId={twoFaAuthFormId} />
    </>
  );
});

export { TwoFAStep };
